import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface HolidaysService {
  getHolidays(year: number): angular.IPromise<apsViewModels.Holiday[]>;
  addHoliday(command: AddHolidayCommand): angular.IPromise<any>;
  deleteHoliday(command: DeleteHolidayCommand): angular.IPromise<any>;
}

export interface AddHolidayCommand {
  date: Date;
  name: string;
}

export interface DeleteHolidayCommand {
  id: string;
}

export default angular
  .module('aps.services.holidays', [HttpServiceName])
  .service('holidaysService', function (httpService: HttpService): HolidaysService {

    var getHolidays = (year: number) => {
        return (httpService.get<apsViewModels.Holiday[]>(Endpoints.HOLIDAYS + '?year=' + year.toString())
          .then((data) => {
              return data;
          }));
    };

    var addHoliday = (command: AddHolidayCommand) => {
      return httpService.put<any>(Endpoints.HOLIDAYS, command);
    };

    var deleteHoliday = (command: DeleteHolidayCommand) => {
      return httpService.delete<any>(Endpoints.HOLIDAYS + '/' + command.id);
    };

    return {
      getHolidays: getHolidays,
      addHoliday: addHoliday,
      deleteHoliday: deleteHoliday
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/services/holidays/holidays.service.ts